module.exports = __webpack_public_path__ + "assets/624312ea0f14ac5fca52b4bb2c7829e3.mp3";